import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

// W-0779 — Opções de Impressão. PARADOXO DE NOMENCLATURA (q-A-W0779-003): captions verbatim do
// Delphi mapeados para as flags corretas:
//   'Administradores' -> incluirAdministradores -> tabela Razao_Socio (histórico)
//   'Responsável'     -> incluirResponsavel     -> campos do próprio master (cdLista)
//   'Sócios'          -> incluirSociosAtuais    -> tabela socios (atual com %)
//   'CC'              -> incluirContaCapital    -> tabela Conta_Capital
// Defaults: TODOS desmarcados (REPLICA-DELPHI). Não inverter o paradoxo.
const CHECKBOXES = [
  { campo: 'incluirAdministradores', label: 'Administradores' },
  { campo: 'incluirResponsavel', label: 'Responsável' },
  { campo: 'incluirSociosAtuais', label: 'Sócios' },
  { campo: 'incluirContaCapital', label: 'CC' },
];

const TIPOS_RELATORIO = [
  { value: 'analitico', label: 'Analítico (detalhado)' },
  { value: 'sintetico', label: 'Sintético (simples)' },
];

const ORDENS = [
  { value: 'razao_social', label: 'Razão Social' },
  { value: 'ge_e_razao_social', label: 'GE e Razão Social' },
];

const OpcoesImpressao = ({ valores, onChange }) => {
  const setCampo = (campo, valor) => onChange({ ...valores, [campo]: valor });

  return (
    <div className="mb-3">
      <Row className="mb-2">
        <Col xs={12}>
          <Form.Label className="small mb-1 d-block">Seções a incluir</Form.Label>
          <div className="d-flex flex-wrap">
            {CHECKBOXES.map((cb) => (
              <Form.Check
                key={cb.campo}
                type="checkbox"
                id={`secao-${cb.campo}`}
                className="mr-4"
                label={cb.label}
                checked={!!valores[cb.campo]}
                onChange={(e) => setCampo(cb.campo, e.target.checked)}
              />
            ))}
          </div>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col xs={12} md={6}>
          <Form.Label className="small mb-1 d-block">Tipo de Relatório</Form.Label>
          <div className="d-flex flex-wrap">
            {TIPOS_RELATORIO.map((t) => (
              <Form.Check
                key={t.value}
                type="radio"
                id={`tipo-rel-${t.value}`}
                name="tipoRelatorio"
                className="mr-4"
                label={t.label}
                checked={valores.tipoRelatorio === t.value}
                onChange={() => setCampo('tipoRelatorio', t.value)}
              />
            ))}
          </div>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label className="small mb-1 d-block">Ordenação</Form.Label>
          <div className="d-flex flex-wrap">
            {ORDENS.map((o) => (
              <Form.Check
                key={o.value}
                type="radio"
                id={`ordem-${o.value}`}
                name="ordem"
                className="mr-4"
                label={o.label}
                checked={valores.ordem === o.value}
                onChange={() => setCampo('ordem', o.value)}
              />
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default OpcoesImpressao;
